import * as React from "react";
import { makeStyles, Spinner, Text } from "@fluentui/react-components";
import IanHeader from "./IanHeader";
import ChatView from "./ChatView";
import SettingsDrawer from "./SettingsDrawer";
import { useMailboxItem } from "../hooks/useMailboxItem";
import { useRoamingConfig } from "../hooks/useRoamingConfig";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    backgroundColor: "var(--bg-primary, #FFFFFF)",
    fontFamily: "var(--font-body, 'Avenir Next LT Pro', 'Segoe UI', sans-serif)",
    overflow: "hidden",
  },
  bootLoader: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    gap: "16px",
    padding: "24px",
  },
});

const App = () => {
  const styles = useStyles();
  const { email, loading: emailLoading, error: emailError } = useMailboxItem();
  const [config, updateConfig] = useRoamingConfig();
  const [settingsOpen, setSettingsOpen] = React.useState(false);

  const handlePersonaChange = React.useCallback(
    (personaKey) => updateConfig({ persona: personaKey }),
    [updateConfig]
  );

  const handleWorkflowChange = React.useCallback(
    (workflowId) => {
      const next = { ...(config.activeWorkflow || {}), [config.persona]: workflowId };
      updateConfig({ activeWorkflow: next });
    },
    [config.activeWorkflow, config.persona, updateConfig]
  );

  if (emailLoading && !email) {
    return (
      <div className={styles.bootLoader}>
        <Spinner size="large" />
        <Text size={400} weight="semibold" style={{ color: "var(--color-info, #13A3E0)" }}>
          Initializing IAN Assist...
        </Text>
        <Text size={200} style={{ color: "var(--text-tertiary, #6E747D)", textAlign: "center" }}>
          Reading your email. This will just take a moment.
        </Text>
      </div>
    );
  }

  const personaCustom = (config.customWorkflows || {})[config.persona] || [];
  const activeWorkflowId = (config.activeWorkflow || {})[config.persona] || "";

  return (
    <div className={styles.root}>
      <IanHeader
        persona={config.persona}
        onPersonaChange={handlePersonaChange}
        activeWorkflowId={activeWorkflowId}
        onWorkflowChange={handleWorkflowChange}
        customWorkflows={personaCustom}
        onSettingsClick={() => setSettingsOpen(true)}
      />

      <ChatView
        email={email}
        config={config}
        emailLoading={emailLoading}
        emailError={emailError}
      />

      <SettingsDrawer
        open={settingsOpen}
        onClose={() => setSettingsOpen(false)}
        config={config}
        onConfigChange={updateConfig}
      />
    </div>
  );
};

export default App;
